import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AssertionForm from "./AssertionForm";
import { Assertion, AssertionRequest } from "../../types";

interface AssertionModalProps {
  open: boolean;
  onClose: () => void;
  initialData?: Assertion;
  isEdit?: boolean;
  onSubmit?: (values: AssertionRequest) => Promise<void>;
}

const AssertionModal: React.FC<AssertionModalProps> = ({
  open,
  onClose,
  initialData,
  isEdit = false,
  onSubmit,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          maxHeight: "90vh",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {isEdit ? "Edit Assertion" : "Create New Assertion"}
        <IconButton
          edge="end"
          color="inherit"
          onClick={onClose}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ py: 1 }}>
          <AssertionForm
            initialData={initialData}
            isEdit={isEdit}
            isModal={true}
            onCancel={onClose}
            onSubmit={onSubmit}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AssertionModal;
